'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/Warning.js";
var n = Object.defineProperty, f = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var t = (e, r, o) => r in e ? n(e, r, { enumerable: true, configurable: true, writable: true, value: o }) : e[r] = o, m = (e, r) => {
  for (var o in r || (r = {}))
    s.call(r, o) && t(e, o, r[o]);
  if (a)
    for (var o of a(r))
      c.call(r, o) && t(e, o, r[o]);
  return e;
}, i = (e, r) => f(e, p(r));
const I = forwardRef((e, r) => /* @__PURE__ */ a__default.createElement(b, i(m({ ref: r }, e), { weights: t$1 })));
I.displayName = "Warning";
export {
  I as Warning
};
